/**
 * TeamWorkloadSection utilities
 * @module pages/DashboardPage/components/TeamWorkloadSection
 */

/** Number of team members displayed per carousel page */
export const MEMBERS_PER_PAGE = 7;
